import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        supportedLngs: ['en', 'de', 'it', 'fr'],
        // If browser is en-US, load 'en' only:
        load: 'currentOnly',
        nonExplicitSupportedLngs: true,

        ns: ['common'],
        defaultNS: 'common',

        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json'
        },

        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'querystring', 'navigator', 'htmlTag'],
            caches: ['localStorage']
        },

        debug: true  // temporarily enable to see what loads
    });

export default i18n;
